import React from 'react';

import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';

import { ONE_MEGABYTE } from '@clearverify/constants';

import { type ActivityLogItemFragment, ActivityLogType } from 'src/api';
import { CLEARVERIFY_LOGO } from 'src/assets';
import { ActivityLogItem } from 'src/components/activityLog';

export const TimelineItemsSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Timeline (Activity log) Items</Typography>

      <Box display="flex" flexDirection="column" gap={2} mt={2}>
        {activityLogItems.map(item => (
          <ActivityLogItem key={item.id} activityLog={item} />
        ))}
      </Box>
    </Box>
  );
};

const now = DateTime.now();

const commentText =
  'It was the best, we arrives just in time for snow. It was so beatiful, I’ll post an albim soon of FB.It was the best, we arrives just in time for snow. It was so beatiful, I’ll post an albim soon of FBIt was the best, we arrives just in time for snow. It was so beatiful, I’ll post an albim soon of FBIt was the best, we arrives just in time for snow. It was so beatiful, I’ll post an albim soon of FB';

const activityLogItemDefaults = {
  companyDisplayName: null,
  authorDisplayName: null,
  comment: null,
  platformStaffId: null,
  file: null,
} satisfies Partial<ActivityLogItemFragment>;

const activityLogItems: ActivityLogItemFragment[] = [
  {
    ...activityLogItemDefaults,
    id: '1',
    createdAt: now.toISO(),
    type: ActivityLogType.Accepted,
    heading: 'Viewed by Verifier Sam Smith',
    visibleFor: [],
  },
  {
    ...activityLogItemDefaults,
    id: '2',
    createdAt: now.minus({ minutes: 30 }).toISO(),
    type: ActivityLogType.Commented,
    heading: 'Consumer Jhon Doe added comment',
    comment: commentText,
    visibleFor: [],
  },
  {
    ...activityLogItemDefaults,
    id: '3',
    createdAt: now.minus({ minutes: 60 }).toISO(),
    type: ActivityLogType.Downloaded,
    heading: 'Verifier Jessica Smith downloaded Verification Report',
    visibleFor: [],
  },
  {
    ...activityLogItemDefaults,
    id: '4',
    createdAt: now.toISO(),
    type: ActivityLogType.Commented,
    heading: 'Consumer Jhon Doe added comment:',
    comment: commentText,
    visibleFor: [],
    file: {
      id: '1',
      filename: 'Clear Verify Logo.svg',
      downloadUrl: CLEARVERIFY_LOGO,
      mime: 'image/svg+xml',
      size: ONE_MEGABYTE * 3.22,
      key: '',
      updatedAt: '',
      createdAt: '',
    },
  },
];
